import { render, staticRenderFns } from "./ProductsToWithdrawHeader.vue?vue&type=template&id=c395fc84&scoped=true"
import script from "./ProductsToWithdrawHeader.vue?vue&type=script&lang=ts"
export * from "./ProductsToWithdrawHeader.vue?vue&type=script&lang=ts"
import style0 from "./ProductsToWithdrawHeader.vue?vue&type=style&index=0&id=c395fc84&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c395fc84",
  null
  
)

export default component.exports